export enum StepValidationStatuses {
  Wait = 'wait',
  Process = 'process',
  Finish = 'finish',
  Error = 'error',
}
